export const IconCloudFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconCloudFilled_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconCloudFilled_svg__a)">
        <path d="M6.5 20q-2.275 0-3.887-1.575T1 14.575q0-1.95 1.175-3.475Q3.349 9.575 5.25 9.15a6.97 6.97 0 0 1 2.138-3.4A6.86 6.86 0 0 1 11 4.075v8.075l-.9-.875A.93.93 0 0 0 9.413 11q-.414 0-.713.3a.95.95 0 0 0-.275.7q0 .425.275.7l2.6 2.6q.3.3.7.3t.7-.3l2.6-2.6a.98.98 0 0 0 .287-.687.93.93 0 0 0-.287-.713.98.98 0 0 0-.687-.288.97.97 0 0 0-.713.263l-.9.875V4.075q2.575.35 4.288 2.312Q19 8.35 19 11q1.725.2 2.863 1.488A4.4 4.4 0 0 1 23 15.5q0 1.875-1.312 3.188Q20.375 20 18.5 20z" />
      </g>
    </svg>
  );
};
